export enum SellarCreditCheckDialogPage {
  COMPLETED_TWO_ONBOARDING,
  ATTACH_BUSINESSES_TO_LEGAL_ENTITY,
  ASSIGN_SELLAR_CREDIT_ACCESS,
}
